import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const importHolder = (id, gaid) => request.post(`${API_BASE_URL}/blockchain/import`, { id: id, gaid: gaid })

export default importHolder